import React from "react";
import { Form, Icon, Input, Alert } from "antd";
import Button from "../../components/common/Button";
import { persistUserAuthData } from "../../utils/persistStorage";
import { Link } from "react-router-dom";
const FormItem = Form.Item;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class LoginScreen extends React.Component {
  state = {
    formError: "",
    showLinkToRequestVerification: false
  };
  componentDidMount() {
    // To disabled submit button at the beginning.
    this.props.form.validateFields();
    console.log("checking route params", this.props.location.search);
    // Parse the searchstring
    const searchString = this.props.location.search;
    if (searchString) {
      const [key, value] = searchString.split("=");
      console.log(key, value);
      if (key == "?verified" && value == "false") {
        this.setState({
          showLinkToRequestVerification: true
        });
      }
    }
  }

  handleSubmit = async (e, mutation) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        try {
          fetch(process.env.REACT_APP_LOGIN_URL, {
            method: "POST",
            headers: {
              "Content-Type": "application/json; charset=utf-8"
              // "Content-Type": "application/x-www-form-urlencoded",
            },
            body: JSON.stringify(values)
          })
            .then(response => response.json())
            .then(res => {
              const { user, token, error } = res;
              console.log("resulting: ", res);
              if (error) {
                this.setState({
                  formError:
                    error.message || "Error signin in, please try again"
                });
              } else {
                token && persistUserAuthData(token);
                this.props.history.push("/");
              }
            });
        } catch (e) {
          console.log("Error signing up: ", e);
        }
      }
    });
  };

  _navigateToRequestVerification = () =>
    this.props.history.push("/auth/request_verification");

  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form;
    const { formError, showLinkToRequestVerification } = this.state;

    return (
      <React.Fragment>
        {showLinkToRequestVerification && (
          <Alert
            message="Your account is not verified"
            type="warning"
            showIcon
            closeText="Request Verification"
            afterClose={this._navigateToRequestVerification}
            style={{ marginBottom: 10 }}
          />
        )}
        <Form onSubmit={e => this.handleSubmit(e)}>
          <FormItem>
            {getFieldDecorator("email")(
              <Input
                prefix={
                  <Icon type="mail" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                placeholder="Email"
              />
            )}
          </FormItem>
          <FormItem>
            {getFieldDecorator("password", {
              rules: [
                {
                  required: true,
                  message: "Please input your password!"
                },
                {
                  validator: this.validateToNextPassword
                }
              ]
            })(
              <Input
                prefix={
                  <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                type="password"
                placeholder="Password"
              />
            )}
          </FormItem>
          <FormItem>
            <Button
              disabled={hasErrors(getFieldsError())}
              block
              type="primary"
              htmlType="submit"
              text="Log In"
              buttonColor="yellow"
            />
          </FormItem>
        </Form>
        <div style={{ textAlign: "center", fontSize: "89%" }}>
          <Link className="auth-small-link" to="/auth/signup">
            Sign Up
          </Link>
        </div>

        <div>
          <small style={{ color: "red" }}>{formError}</small>
        </div>
      </React.Fragment>
    );
  }
}

const WrappedLoginScreen = Form.create()(LoginScreen);

export default WrappedLoginScreen;
